import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// import Link from "@mui/material/Link";

const cardStyle = {
  bgcolor: "#fff",
  color: "#4f4f4f",
};

const data = [
  {
    title: "BAV FEED AFRICA (2019 - 2020)",
    description1:
      "The Bayelsa State Government contracted Aquatic Hub Afrique Network, the training partner of Aquaseas Company Limited, to lead an ambitious project aimed at fostering aquaculture enterprise development in the region. This initiative was designed to empower 1,000 women and youth across Bayelsa with practical skills in aquaculture, specifically fish farming, equipping them to establish and sustain profitable ventures. The program, running from 2019 to 2020, was divided into four comprehensive cohorts, each focusing on various aspects of fish farming, including hatchery management, feed formulation, and marketing strategies.",
    description2:
      "Through the collaboration with Blue-Echo Foundation, the project also emphasized the importance of sustainable aquaculture practices, ensuring that participants gained not only technical knowledge but also an understanding of environmental stewardship. By the program's conclusion, these individuals were empowered to contribute significantly to the local economy, enhance food security, and promote the production and consumption of farmed fish, particularly tilapia, in the region.",
  },
  {
    title: "WORLD BANK APPEALS PROJECT (2019 - 2020)",
    description1:
      "Aquatic Hub Afrique Network, in collaboration with the Blue-Echo Foundation, played a pivotal role in the successful implementation of the World Bank-supported APPEALS (Agro-Processing, Productivity Enhancement and Livelihood Improvement Support) project from 2019 to 2020. As part of this initiative, Aquatic Hub Afrique Network was contracted to provide comprehensive training to 502 beneficiaries in Aquaculture Enterprise Development, with the primary goal of equipping them with the necessary skills to thrive in the aquaculture sector.",
    description2:
      "The training program was designed to deliver hands-on knowledge across the entire aquaculture value chain, enabling participants to not only understand the core principles of fish farming but also to explore opportunities in fish processing, feed production, and aquaculture-related services. Each beneficiary received in-depth training in modern aquaculture techniques, including cage culture, pond management, breeding, and hatchery operations. Furthermore, participants were exposed to Good Aquaculture Practices (GAP) and trained on how to maintain high standards of sustainability and environmental responsibility in their operations.",
  },
  {
    title: "BATNF FTF PROJECT (2020 - 2021)",
    description1:
      "Aquatic Hub Afrique Network, in collaboration with the Blue-Echo Foundation, successfully implemented the British American Tobacco Nigeria Foundation (BATNF) 'Fingerlings to Fork' (FTF) project in April 2021, in Yenagoa, Bayelsa State. This transformative initiative aimed to empower 300 women and youth by equipping them with the skills and knowledge needed to thrive in the aquaculture sector, a crucial industry for food security and economic development.",
    description2:
      "The beneficiaries underwent comprehensive training focused on modern, sustainable aquaculture techniques, with a strong emphasis on 21st-century Good Aquaculture Practices (GAP). These practices included fish farming innovations that are environmentally friendly, economically viable, and socially responsible, ensuring that participants were well-prepared to contribute to sustainable food production systems. In addition to learning core aquaculture skills, participants were introduced to fish processing and value addition methods. The top-performing cohort was awarded a modern smoking kiln, a vital tool that enhances the preservation and marketability of fish products. This not only improves the shelf life of fish but also allows the beneficiaries to tap into new market opportunities, boosting their incomes and economic independence.",
  },
];

const Others = () => {
  return (
    <Box margin={{ xs: "0% 0% 10% 0%", sm: "1% 0% 5% 0%" }}>
      <Typography variant={"body1"}>
        We have worked with developmental partners including the World Bank,
        Food and Agriculture Organization, International Fund for Agricultural
        Development (IFAD), GIZ, British American Tobacco Foundation, AFOS
        Foundation, among others. With our collaborative efforts, we have been
        able to reach over 42,853 farmers, provided starter kits to 3,237
        farmers and also held 34 capacity building programs and sessions across
        17 states.
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { title, description1, description2 } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                marginTop={{ xs: "10%", sm: "3%" }}
              >
                <Box
                  component={Card}
                  height={"100%"}
                  padding={"5% 6%"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  margin={{ xs: "4% 0%", sm: "2% 0%" }}
                  data-aos={"fade-down"}
                  sx={{ ...cardStyle }}
                >
                  <Typography
                    variant={"h4"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#317ABE"}
                  >
                    {title}
                  </Typography>
                  <Typography variant={"body1"} paddingTop={"6%"}>
                    {description1}
                  </Typography>
                  <Typography variant={"body1"} paddingTop={"3%"}>
                    {description2}
                  </Typography>
                  <Grid item xs={12} marginTop={{ xs: "0%", sm: "4%" }}>
                    <Divider color={"#fff"} />
                  </Grid>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Others;
